import PigGroupCommitmentsPanel from './PigGroupCommitmentsPanel';

export default PigGroupCommitmentsPanel;
